import {classNames, hasText} from "utils/helpers";
import './answer-explanation.less';
import {sanitizeEditorPreviewHtml} from "utils/html-sanitization";
import {useMemo, useState } from "react";

export type AnswerExplanationPosition = "top"|"bottom"

interface Props {
  answerExplanation: string|null|undefined
  position?: AnswerExplanationPosition
}

export default function AnswerExplanation(props: Props) {
  const [state, setState] = useState({
    isExpanded: true
  })
  const {answerExplanation} = props;
  const text = useMemo(() => {
      return sanitizeEditorPreviewHtml(answerExplanation || '')
  }, [answerExplanation])
  
  function handleShrinkClicked() {
    
  }
  
  function handleExpandClicked() {
    
  }
  
  if (!hasText(text)) {
    return null;
  }
  
  return <>
    <div 
      className={classNames("answer-explanation default-shadow-on-all-sides", {
        "bottom": props.position === "bottom",
        "top": props.position === "top",
      })}
      onClick={handleShrinkClicked}
    >
      <div className="explanation-text" dangerouslySetInnerHTML={{__html: text}}>
      </div>
      <div className="explanation-icon" />  
    </div>
  </>
}